module.exports = __webpack_public_path__ + "static/media/resume.37b4e967.pdf";